import CircularProgress, {
  type CircularProgressProps,
} from '@mui/material/CircularProgress';

const LoadingSpinner = ({ sx, ...props }: CircularProgressProps) => (
  <CircularProgress
    size={14}
    {...props}
    sx={[
      { color: 'background.menuBorder' },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);

export default LoadingSpinner;
